import { BusDetailsCard, ReturnButton, SidePanel } from "_components";
import { contextActions, dataCollectorActions, eventsActions, vehicleActions } from "_store";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { DatasBusMap, DatasTableBusDataCollector, DatasTableBusLastEvents } from ".";
import DataBusSocGraphs from "./Datas.Bus.SOC.Graphs";
import { SettingsLayout } from "views/settings";
import { WarningsList } from "_components/WarningList";

export { DataBus };

/**
 * Page d'affichage des données d'un bus
 * Regroupe une carte d'information générales, la liste des voyants de ce bus,
 * son emplacement et trajet des 15 dernières minutes,
 * le tableau des derniers évènements et deux graphiques liés à l'énergie
 * Les données sont récupérées avec les actions (slices redux) :
 *  - vehicles
 *  - context
 *  - event
 * @returns 
 */
function DataBus() {

    const { busVin } = useParams();

    const dispatch = useDispatch();

    const [warnings, setWarnings] = useState();
    const [voyants, setVoyants] = useState();
    const [lastPositions, setLastPositions] = useState();
    const [details, setDetails] = useState();
    const [height, setHeight] = useState(0);

    const busDetails = useSelector(state => state.vehicles?.selectedVehicleDetails);
    const contextDetails = useSelector(state => state.contextDetails);
    const events = useSelector(state => state.events);
    const dataCollector = useSelector(state => state.dataCollector);

    useEffect(() => {
        if (!contextDetails?.data){
            dispatch(contextActions.getContextDetail());
        }
    }, [])


    useEffect(() => {
        if (dataCollector){
            console.log("Data Collector mis à jour :", dataCollector);
        }
    }, [dataCollector] )

    useEffect(() => {
        if (busVin){
            dispatch(vehicleActions.clearData());
            dispatch(eventsActions.clearData());
            dispatch(dataCollectorActions.clearData());

            dispatch(eventsActions.getLastEventsByVin(busVin))
            dispatch(vehicleActions.getVehicleWarnings(busVin));
            dispatch(vehicleActions.getVehicleLastPositions(busVin));
            dispatch(dataCollectorActions.getData(busVin));
        }

        //return () => dataCollectorActions.clearData();
    }, [busVin])

    //Pour adapter la hauteur de la div contenant la map sur la hauteur de la carte
    useEffect(() => {
       const observer = new MutationObserver(() => {
            const busDetailsCard = document.getElementById('bus-details-card');
            const mapContainer = document.getElementById('data-bus-map-container');
            if (busDetailsCard && mapContainer) {
                const height = busDetailsCard.offsetHeight;
                if (height > 0) {
                    mapContainer.style.height = `${height}px`;
                    setHeight(height)
                    observer.disconnect(); // arrête l'observation une fois la hauteur ajustée
                }
            }
        });

        observer.observe(document.body, { childList: true, subtree: true });

        return () => observer.disconnect();
    }, []);

    //Affectation de variables d'état
    useEffect(() => {
        if (busDetails){
            setDetails(busDetails);
        }
        if (busDetails &&  busDetails.warnings){
            setWarnings(busDetails.warnings);
        }
        if (busDetails &&  busDetails.warnings && busDetails.warnings.voyants){
            setVoyants(busDetails.warnings.voyants);
        }
        if (busDetails && busDetails.lastPosition && busDetails.lastPosition.features[0]){
            setLastPositions(busDetails.lastPosition.features[0])
        }
    }, [busDetails])
    
    return (               
        <div className="px-10 pb-10 justify-center">
            <SettingsLayout />
            <SidePanel />
            <ReturnButton />
            <div className="flex gap-4 mb-4 p-4 items-stretch">                    
                <div id="bus-details-card" className="w-1/3 flex flex-col h-full">
                    {warnings && 
                    <BusDetailsCard warnings={warnings} />}
                </div>
                <div className="px-4 flex flex-col w-1/3 h-full">
                    <div className="small-title-customtable mb-4">
                        Voyants
                    </div>   
                    {voyants &&                  
                    <WarningsList warnings={voyants} />}                        
                </div>
                <div id="data-bus-map-container" className="data-bus-map-container flex w-1/3">
                    {lastPositions && height > 0 &&
                    <DatasBusMap bus={lastPositions} height={height}/>}
                </div>     
            </div>                              
            <div className="flex gap-4 max-h-[75vh]">                        
                <div className="w-full h-full">
                    {events &&
                    <DatasTableBusLastEvents events={events}/>}
                </div>
            </div>
            <div className="flex gap-4 max-h-[75vh]">                        
                <div className="w-full h-full">
                    {dataCollector &&
                    <DatasTableBusDataCollector dataCollector={dataCollector}/>}
                </div>
            </div>  
            <div className="flex gap-4 w-full mt-4">
                {details &&
                <DataBusSocGraphs busDetails={details} />}
            </div>
        </div>   
    );
}